<template>
	<div class="post-smtp-logs-wrapper">

		<div class="post-smtp-logs-header">
			<div class="float-left">
				<h2>{{ i18n.__( 'Recent Logs', 'post-smtp' ) }}</h2>
			</div>
			<div class="float-right">
				<a :href="get_logs_url">{{ i18n.__( 'View All', 'post-smtp' )}}</a>
			</div>
		</div>

		<div class="post-smtp-logs-body">

			<table v-if="is_post_smtp_logs_are_ready">
				<thead>
				<tr>
					<th style="text-align: left;width: 253px;">{{ i18n.__( 'Subjects', 'post-smtp' ) }}</th>
					<th style="text-align: left;width: 233.01px;">{{ i18n.__( 'Sent to', 'post-smtp' ) }}</th>
					<th style="text-align: left;width: 192.99px;">{{ i18n.__( 'Delivery time', 'post-smtp' ) }}</th>
					<th style="text-align: left;width: 173px;">{{ i18n.__( 'Status', 'post-smtp' ) }}</th>
				</tr>
				</thead>

				<tbody>
					<tr v-for="item in logs" :key="item.id">
					<td>{{ item.subject }}</td>
					<td>{{ item.sent_to }}</td>
					<td>{{ item.delivery_time }}</td>
					<td>
						<div class="post-smtp-status-wrapper">
							<span v-if="'success' === item.status" class="post-smtp-status post-smtp-success">{{ i18n.__( 'Success', 'post-smtp' ) }}</span>
							<span v-if="'failed' === item.status" class="post-smtp-status post-smtp-failed">{{ i18n.__( 'Failed', 'post-smtp' ) }}</span>

							<post-smtp-log-action-menu
								v-on:email-triggered="getLatestLogs"
								:item="item"
								:dynamic-id="item.id"
							></post-smtp-log-action-menu>
						</div>
					</td>
				</tr>
				</tbody>
			</table>

			<div
				class="post-smtp-logs-empty"
				v-else
			>
				<div class="post-smtp-logs-head">
					<svg width="67" height="48" viewBox="0 0 67 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g clip-path="url(#clip0_155_1001)">
							<path d="M29.9247 6.77262H23.3311V0.504771C23.3311 0.225642 23.1039 0 22.823 0H5.02056C4.73959 0 4.51245 0.225642 4.51245 0.504771V9.85306C4.51245 10.1322 4.73959 10.3578 5.02056 10.3578H28.0168L30.3168 7.59997C30.591 7.2707 30.3555 6.77262 29.9247 6.77262Z" fill="url(#paint0_linear_155_1001)"/>
							<path d="M35.8433 3.5499L28.9266 11.8435H1.52731C0.659146 11.8435 -0.034039 12.5622 0.00129318 13.423L1.39776 46.2648C1.43309 47.0772 2.1044 47.7173 2.92209 47.7173H63.5774C64.3934 47.7173 65.0648 47.0788 65.1018 46.2699L66.9979 4.58451C67.0366 3.72206 66.3434 3 65.4736 3H37.016C36.5617 3 36.131 3.20057 35.8416 3.54823L35.8433 3.5499Z" fill="url(#paint1_linear_155_1001)"/>
						</g>
						<defs>
							<linearGradient id="paint0_linear_155_1001" x1="17.4726" y1="5.17975" x2="17.4726" y2="18.028" gradientUnits="userSpaceOnUse">
								<stop stop-color="#ECF2FF"/>
								<stop offset="1" stop-color="#DCE7FF"/>
							</linearGradient>
							<linearGradient id="paint1_linear_155_1001" x1="33.5013" y1="18.7916" x2="33.5013" y2="45.4492" gradientUnits="userSpaceOnUse">
								<stop stop-color="#ECF2FF"/>
								<stop offset="1" stop-color="#DCE7FF"/>
							</linearGradient>
							<clipPath id="clip0_155_1001">
								<rect width="67" height="48" fill="white"/>
							</clipPath>
						</defs>
					</svg>
				</div>
				<div class="post-smtp-logs-content">
					<h3>{{ i18n.__( 'No Data Available', 'post-smtp' ) }}</h3>
					<p>{{ i18n.__( 'Once you configured the Post SMTP, the logs will be available here.', 'post-smtp' ) }}</p>
				</div>
				<div v-if="! postSmtpConfigured" class="post-smtp-logs-footer">
					<a :href="wizard_url">{{ i18n.__( 'Configure Now', 'post-smtp' ) }}</a>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default {
	name: 'PostSmtpLogsSection',

	inject: [ 'i18n' ],

	props: {
		postSmtpConfigured: {
			type: Boolean,
			default: false,
		},
	},

	data: ( vm ) => ( {
		plugin_dir_url: vm.$parent.plugin_dir_url,
		admin_url: vm.$parent.admin_url,

		logs: [],
	} ),

	watch: {},

	computed: {
		is_post_smtp_logs_are_ready() {
			return this.logs.length;
		},

		get_logs_url() {
			return `${this.admin_url}?page=postman_email_log`;
		},

		wizard_url() {
			return `${this.admin_url}?page=postman/configuration_wizard`;
		}
	},

	methods: {

		get_logs() {
			axios.get( 'get-logs' )
				.then( response => {
					this.logs = response.data.logs;
				} );
		},

		getLatestLogs() {
			this.get_logs();
		},

		showHideLogActionMenu( item ) {
			var display;

			if ( item.show_log_menu ) {
				display = 'block';
			} else {
				display = 'none';
			}

			return {
				display: display,
			}
		}
	},

	mounted() {
		this.get_logs();

		document.body.addEventListener( 'click', ( event ) => {
			if ( ! event.target.closest( '.email-menu-wrapper' ) ) {
				this.logs.forEach( ( log ) => {
					log.show_log_menu = false;
				} );

			}
		} );
	},
}
</script>

<style scoped>

.post-smtp-logs-wrapper * {
	padding: 0;
	margin: 0;
}

.post-smtp-logs-wrapper {
	width: 100%;
}

.post-smtp-logs-header {
	width: calc( 100% - 2px - 48px );
	height: calc( 52px - 1px - 32px );

	padding: 16px 24px;

	border-radius: 4px 4px 0px 0px;
	border-top: 1px solid #DCDFE5;
	border-right: 1px solid #DCDFE5;
	border-left: 1px solid #DCDFE5;
	background: #EFF4FD;
}

.post-smtp-logs-body {
	width: calc( 100% - 2px );

	border-radius: 0px 0px 4px 4px;
	border-right: 1px solid #DCDFE5;
	border-bottom: 1px solid #DCDFE5;
	border-left: 1px solid #DCDFE5;
	background: #FFF;
}

.post-smtp-logs-body th,
.post-smtp-logs-body td {
	height: 48px;
	padding: 0 16px;
}

.post-smtp-logs-header::after {
	content: '';
	display: block;
	clear: both;
}

.float-left {
	float: left;
}

.float-right {
	float: right;
}

.post-smtp-logs-header h2 {
	color: #231F20;
	text-align: center;
	font-family: Poppins;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 20px; /* 125% */
}

.post-smtp-logs-header a {
	color: #375CAF;
	text-align: center;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 20px; /* 166.667% */
	text-decoration-line: underline;
}

.post-smtp-logs-body table {
	width: 100%;
}

.post-smtp-logs-body table thead th {
	color: #231F20;
	text-align: center;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 14px; /* 100% */
}

.post-smtp-logs-body table tbody td {
	color: #646464;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */

	border-bottom: 1px solid #DCDFE5;
}

.post-smtp-logs-body table tbody tr:last-child td {
	border-bottom: none;
}

.post-smtp-logs-body table tbody td {
	text-align: left;
}

.post-smtp-status {
	display: inline-flex;
	padding: 4px;
	flex-direction: column;
	align-items: center;
	text-align: center;
	font-family: Poppins;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	line-height: 12px; /* 120% */
	border-radius: 14px;
	width: 62px;
}

.post-smtp-status.post-smtp-success {
	color: #74B27B;
	background: #EDFFEF;
}

.post-smtp-status.post-smtp-failed {
	color: #E57373;
	background: #FFEDED;
}

.post-smtp-status-wrapper {
	width: 100%;
	position: relative;
}

.post-smtp-logs-empty {
	width: 100%;
	height: 300px;

	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}

.post-smtp-logs-empty .post-smtp-logs-head {}

.post-smtp-logs-empty .post-smtp-logs-content {
	text-align: center;

	margin-bottom: 16px;
	margin-top: 24px;
}

.post-smtp-logs-empty .post-smtp-logs-content h3 {
	color: #646464;
	text-align: center;
	font-family: Poppins;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 14px; /* 100% */
	margin-bottom: 8px;
}

.post-smtp-logs-empty .post-smtp-logs-content p {
	color: #646464;
	text-align: center;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */
}

.post-smtp-logs-empty .post-smtp-logs-footer a {
	display: block;
	color: #FFF;
	font-family: Poppins;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px; /* 150% */

	padding: 8px 16px;
	justify-content: center;
	align-items: center;
	gap: 4px;

	border-radius: 4px;
	background: #375CAF;

	text-decoration: none;
}
</style>